webpackJsonp([267695594480457],{

/***/ 53:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var JobList = function (_React$Component) {
	  _inherits(JobList, _React$Component);
	
	  function JobList() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, JobList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      show: 60
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  JobList.prototype.componentWillMount = function componentWillMount() {
	    this.setState({ jobs: this.props.jobs });
	  };
	
	  JobList.prototype.componentDidMount = function componentDidMount() {
	    document.addEventListener('scroll', this.handleScroll.bind(this), true);
	  };
	
	  JobList.prototype.componentWillUnmount = function componentWillUnmount() {
	    document.removeEventListener('scroll', this.handleScroll.bind(this), true);
	  };
	
	  JobList.prototype.handleScroll = function handleScroll() {
	    var bottom = window.innerHeight;
	    var scroll = document.body.getBoundingClientRect().bottom - 10;
	    if (scroll <= bottom) {
	      this.showMore();
	    }
	  };
	
	  JobList.prototype.showMore = function showMore() {
	    var currentlyShown = this.state.show;
	    if (this.state.show <= this.state.jobs.length) this.setState({ show: currentlyShown + 60 });
	  };
	
	  JobList.prototype.filterJobs = function filterJobs(event) {
	    event.target.value.length > 0 ? this.setState({ filtered: true }) : this.setState({ filtered: false });
	    var updatedList = this.props.jobs;
	    updatedList = updatedList.filter(function (job) {
	      var query = event.target.value.toLowerCase().replace(/\W/g, '');
	      var title = job.node.title.toLowerCase();
	      var company = job.node.company.toLowerCase();
	      var tags = job.node.tags.join(' ').toLowerCase();
	      if (title.search(query) !== -1 || company.search(query) !== -1 || tags.search(query) !== -1) {
	        return true;
	      }
	      // return title.search(query) !== -1
	    });
	    this.setState({ jobs: updatedList });
	  };
	
	  JobList.prototype.render = function render() {
	    var _this2 = this;
	
	    var style = {
	      search: {
	        display: 'block',
	        width: '600px',
	        maxWidth: '100%',
	        margin: '0 auto',
	        border: '0',
	        borderRadius: '.25rem',
	        padding: '1rem',
	        boxShadow: '0 15px 35px rgba(50,50,93,.1), 0 5px 15px rgba(0,0,0,.07)',
	        outline: '0',
	        WebkitAppearance: 'none'
	      }
	    };
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: '3rem' } },
	        _react2.default.createElement('input', {
	          type: 'search',
	          placeholder: 'Search jobs',
	          onChange: this.filterJobs.bind(this),
	          style: _extends({}, style.search)
	        })
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'job-list' },
	        this.state.jobs.map(function (job, i) {
	          var hue = Math.round(Math.abs(((job.node.company ? job.node.company.length : 10) * (Math.ceil(1) - Math.floor(36)) + 1) * 20));
	          if (i < _this2.state.show) return _react2.default.createElement(
	            'li',
	            { key: i, className: 'card' },
	            _react2.default.createElement(
	              'div',
	              { className: 'card__image' },
	              job.node.company_logo ? _react2.default.createElement('div', {
	                style: {
	                  display: 'flex',
	                  justifyContent: 'center',
	                  alignItems: 'center',
	                  background: 'url(' + job.node.company_logo + ')',
	                  backgroundPosition: 'center',
	                  backgroundSize: 'contain',
	                  backgroundRepeat: 'no-repeat',
	                  fontSize: '2em',
	                  padding: '.25em .5em',
	                  height: '3rem',
	                  width: '3rem',
	                  borderRadius: '.25rem'
	                }
	              }) : _react2.default.createElement(
	                'div',
	                {
	                  style: {
	                    display: 'flex',
	                    justifyContent: 'center',
	                    alignItems: 'center',
	                    background: 'linear-gradient(45deg,hsl(' + hue + ', 50%, 60%), hsl(' + hue + ', 50%, 40%))',
	                    color: 'white',
	                    fontSize: '2em',
	                    padding: '.25em .5em',
	                    lineHeight: '1',
	                    height: '3rem',
	                    width: '3rem',
	                    textTransform: 'uppercase',
	                    borderRadius: '.25rem'
	                  }
	                },
	                job.node.company ? job.node.company.charAt(0) : '?'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'card__detail' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  job.node.company
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/' + job.node.slug },
	              _react2.default.createElement(
	                'h3',
	                { className: 'card__heading' },
	                job.node.title
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card__meta' },
	              _react2.default.createElement(
	                'div',
	                null,
	                job.node.tags ? job.node.tags.map(function (tag, i) {
	                  return _react2.default.createElement(
	                    'span',
	                    { className: 'tag', key: i },
	                    tag
	                  );
	                }) : ''
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                style: {
	                  fontSize: '12px',
	                  marginTop: 'auto',
	                  lineHeight: 1,
	                  color: 'hsla(211, 20%, 75%, 1)',
	                  display: 'flex',
	                  justifyContent: 'space-between',
	                  fontStyle: 'italic',
	                  paddingTop: '.25rem'
	                }
	              },
	              _react2.default.createElement(
	                'span',
	                null,
	                job.node.date_pretty
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { maxWidth: '50%' } },
	                job.node.location
	              )
	            ),
	            job.node.logo ? _react2.default.createElement('img', { className: 'card__logo', src: job.node.logo }) : ''
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            marginTop: '2em',
	            padding: '2rem',
	            background: 'hsla(210, 30%, 95%, 1)',
	            borderRadius: '.25rem',
	            textAlign: 'center'
	          },
	          onClick: this.state.jobs.length <= this.state.show ? null : this.showMore.bind(this)
	        },
	        this.state.jobs.length <= this.state.show ? "That's all 🙌" : 'Load more 🎣'
	      )
	    );
	  };
	
	  return JobList;
	}(_react2.default.Component);
	
	exports.default = JobList;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _jobList = __webpack_require__(42);
	
	var _jobList2 = _interopRequireDefault(_jobList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TermsPage = function (_React$Component) {
	  _inherits(TermsPage, _React$Component);
	
	  function TermsPage() {
	    _classCallCheck(this, TermsPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TermsPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'job-post', style: { textAlign: 'left', fontSize: '.8rem' } },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Terms of Use'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Please read these Terms of Use ("Terms", "Terms of Use") carefully before using the https://www.zapgigs.com website (the "Service") operated by ZapGigs ("us", "we", or "our"). Your access to and use of the Service is conditioned upon your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who wish to access or use the Service. By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you do not have permission to access the Service. Intellectual Property The Service and its original content, features and functionality are and will remain the exclusive property of ZapGigs and its licensors. The Service is protected by copyright, trademark, and other laws of both the United States and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of ZapGigs.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Links To Other Web Sites'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Our Service may contain links to third party web sites or services that are not owned or controlled by ZapGigs. ZapGigs has no control over, and assumes no responsibility for the content, privacy policies, or practices of any third party web sites or services. We do not warrant the offerings of any of these entities/individuals or their websites.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'You acknowledge and agree that ZapGigs shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such third party web sites or services. We strongly advise you to read the terms and conditions and privacy policies of any third party web sites or services that you visit.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Termination'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We may terminate or suspend your access to the Service immediately, without prior notice or liability, under our sole discretion, for any reason whatsoever and without limitation, including but not limited to a breach of the Terms. All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Changes'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion. By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized to use the Service.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Contact Us'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you have any questions about these terms, please',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:contact@zapgigs.com' },
	          'contact us.'
	        )
	      )
	    );
	  };
	
	  return TermsPage;
	}(_react2.default.Component);
	
	exports.default = TermsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-terms-js-b813efba8854b3d50aca.js